// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"51f62a82b8a797af734a","883":"a75fea353a601f6a2f33"}[chunkId] + ".js";
};